import { z } from 'zod';
import { unitsOfMeasurementSchema } from './units-of-measurement.schema';
import { vehicleTypeSchema } from './vehicle-type.schema';

export const vehicleDimensionSchema = z.object({
  height: z.number(),
  length: z.number(),
  units: unitsOfMeasurementSchema,
  weight: z.number(),
  width: z.number(),
  maxWeightPerAxleGroup: z.number().optional(),
});

export const vehicleDimensionsThresholdSchema = z.object({
  vehicleDimensionMax: vehicleDimensionSchema,
  vehicleDimensionMin: vehicleDimensionSchema,
  vehicleType: vehicleTypeSchema,
});

export type VehicleDimensionsThreshold = z.infer<
  typeof vehicleDimensionsThresholdSchema
>;
